import script from "./CustomerBirthday.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBirthday.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBirthday.vue?vue&type=style&index=0&id=4853f9d0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4853f9d0"]])

export default __exports__